import Utils from "../../../Scalesoft.Shared.FrontEnd/Scripts/Utils";
import {ConfigContactType} from "../Enums/ConfigContactType";
import IContactConfiguration from "../Registration/Interfaces/IContactConfiguration";
import {ContactType} from "./Enums/ContactType";

declare const contactConfiguration: string;

export default class ContactConfigurationProvider {
    private readonly utils: Utils;

    constructor() {
        this.utils = new Utils();
    }

    public getContactConfiguration(): { [contactType: string]: IContactConfiguration; } {
        if (typeof contactConfiguration !== "undefined") {
            const contactsConfiguration: IContactConfiguration[] = this.utils.resolveReferences(contactConfiguration);

            const contactValidationConfig = {};

            for (const configuration of contactsConfiguration) {

                contactValidationConfig[this.getContactName(configuration.contactType)] = configuration;
            }

            return contactValidationConfig;
        }
        return null;
    }

    private getContactName(type: ConfigContactType): string {
        switch (type) {
            case ConfigContactType.PhoneNumber:
                return ContactType.PhoneNumber;
            case ConfigContactType.Email:
                return ContactType.Email;
            default:
        }
    }
}
